import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiInstance } from '../services/service-trips-api/service-trips-api';
import { toPassengerId } from '../services/service-trips-api/types';
import type { PassengerPendingReviewResponse } from '../services/service-trips-api/types';
import { QueryKeys } from './types';

export const usePassengerPendingReviewQuery = (
  passengerId: number | undefined,
  enabled = false
): UseQueryResult<PassengerPendingReviewResponse> =>
  useQuery<PassengerPendingReviewResponse>({
    queryKey: [QueryKeys.PassengerPendingReview, passengerId],
    queryFn: () => {
      if (passengerId === undefined) {
        return Promise.reject(new Error('passengerId is required to fetch pending review'));
      }
      return apiInstance.getPassengerPendingReview(toPassengerId(passengerId));
    },
    enabled: enabled && !!passengerId,
  });
